
import * as z from 'zod';

// Define the calculator schema
export const calculatorSchema = z.object({
  // Personal Status
  applicantStatus: z.enum(['single', 'couple']),
  dependentSpouse: z.boolean().default(false),
  otherDependents: z.boolean().default(false),
  
  // Income
  grossIncome: z.number().min(0, "Must be a positive number"),
  incomeTax: z.number().min(0, "Must be a positive number"),
  usc: z.number().min(0, "Must be a positive number"),
  prsi: z.number().min(0, "Must be a positive number"),
  propertyTax: z.number().min(0, "Must be a positive number"),
  homeLoanInterest: z.number().min(0, "Must be a positive number"),
  maintenancePayments: z.number().min(0, "Must be a positive number"),
  healthExpenses: z.number().min(0, "Must be a positive number"),
  
  // Assets (Savings and Investments)
  savingsAndCash: z.number().min(0, "Must be a positive number"),
  investments: z.number().min(0, "Must be a positive number"),
  otherAssets: z.number().min(0, "Must be a positive number"),
  
  // Property
  ownsPrimaryResidence: z.boolean(),
  primaryResidenceValue: z.number().min(0, "Must be a positive number"),
  hasOtherProperties: z.boolean(),
  otherPropertiesValue: z.number().min(0, "Must be a positive number"),
  
  // Farm/Business
  hasFarmOrBusiness: z.boolean(),
  farmBusinessValue: z.number().min(0, "Must be a positive number"),
  familySuccessor: z.boolean().default(false),
  
  // Nursing Home
  nursingHomeCost: z.number().min(0, "Must be a positive number"),
  useLoan: z.boolean(),
  yearsInCare: z.number().min(0).max(10, "Must be between 0 and 10 years"),
});

export type CalculatorFormValues = z.infer<typeof calculatorSchema>;
